import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  currentNodeChangedOnDirectLocationGroupClick,
  getCurrentNode,
  getLocationGroupText,
  getLocationQuestionOrder,
  getBuildings,
  getBuildingGroupText,
  getBuildingQuestionOrder,
  getExpressApplication,
  getExpressImportanctFactor,
  getGroupQuestionDetailsFromQuestionTable,
  getProspectDoc
} from "../store/qf";
import CmnGroupHeader from "./CmnGroupHeader";

import * as theme from "../theme";
import LocationGroupOpenedQuestions from "./LocationOpenedQuestions";

const BuildingGroupHeaderAndQuestions = ({
  locationid,
  groupid,
  formid,
  mainDivRef,
  handleShowScroll,
  firstGroupId,
  lastGroupId,
  allinonepage,
  customData,
  isBuilding,
  buildingIndex,
}) => {
  const [open, setOpen] = useState(true);
  const [displayGroup, setdisplayGroup] = useState("block");
  const isExpressApplication = useSelector(getExpressApplication);
  const importanceFactor = useSelector(getExpressImportanctFactor);
  const gotProspectDetails = useSelector(getProspectDoc);
  const groupQuestionDetails = useSelector(
    getGroupQuestionDetailsFromQuestionTable({
      formid,
      groupid,
      locationid,
      buildingid: buildingIndex,
    })
  );

    let anyIntrestedInsurer = (x) => {
    // if intresetedInsures not defined or forceImportance is true we return true
    if(!x?.interestedinsurercodes.length || x?.forceimportance){
      return true
    }
    let trex =  x.interestedinsurercodes.some((r) =>
        gotProspectDetails.interestedinsurercodes.includes(r));
      return trex
      
  }

  const PriorityQuestions = useMemo(() => {
    return (
      groupQuestionDetails?.filter((x) => (x.importance > importanceFactor && anyIntrestedInsurer(x)) || x.answer ) || []
    );
  }, [groupQuestionDetails, importanceFactor, formid]);

  const currentnode = useSelector(getCurrentNode);
  //   const groupText = useSelector(
  //     getLocationGroupText({ formid, groupid, locationid })
  //   );

  // const questionsOrder = useSelector(
  //   getLocationQuestionOrder({ formid, groupid, locationid })
  // );

  const questionsOrder = useSelector(
    getBuildingQuestionOrder({ formid, groupid, locationid, buildingIndex })
  );

  const buildingInfo = useSelector(getBuildings({ formid, locationid }));
  const buildingGroupText = useSelector(
    getBuildingGroupText({ formid, groupid, locationid, buildingIndex })
  );

  const isFirstGroup = groupid === firstGroupId;
  const isLastGroup = groupid === lastGroupId;

  //   const isGroupOpen =
  //     currentnode.groupid === groupid && currentnode.formid === formid;

  const isGroupOpen = true;

  const dispatch = useDispatch();

  useEffect(() => {
    // console.log("buildingInfo", buildingInfo);
    // console.log("buildingIndex", buildingIndex);
    // console.log("buildingIndex", buildingGroupText);
    // console.log("currentnode", currentnode);
    // console.log("buildingGroupText", buildingGroupText);
    let { scrollHeight, clientHeight } = mainDivRef.current;

    if (scrollHeight > clientHeight) {
      handleShowScroll(true);
    } else {
      handleShowScroll(false);
    }
  });

  useEffect(() => {
    if (isGroupOpen === true) setOpen(true);
    //if (isGroupOpen) setOpen(true);
  }, [isGroupOpen]);

  useEffect(() => {
    setOpen(true);
  }, [currentnode.questionid]);

  const handleOpenCloseClick = () => {
    // dispatch(
    //   currentNodeChangedOnDirectLocationGroupClick({ groupid, locationid })
    // );

    setOpen(!open);
    if (isGroupOpen) {
      setOpen(false);
    }

    if (isGroupOpen && open === false) {
      setOpen(true);
    }
  };
  useEffect(() => {
    if (
      isExpressApplication &&
      PriorityQuestions?.length == 0 &&
      groupid != 'e_320'
    ) {
      setdisplayGroup("none");
      setOpen(false);
    } else {
      setdisplayGroup("block");
    }
  }, [isExpressApplication, PriorityQuestions]);

  const minHeightForGroupTab = theme.SCALES.minHeightForGroupTab;

  return (
    <div style={{ minHeight: minHeightForGroupTab, display: displayGroup }}>
      {
        <>
          <CmnGroupHeader
            text={customData?.header ? customData.header : buildingGroupText}
            isComplete={false}
            isOpen={isGroupOpen && open}
            isFirstGroup={isFirstGroup}
            isLastGroup={isLastGroup}
            handleOnClick={handleOpenCloseClick}
            allinonepage={allinonepage}
            customData={customData}
          ></CmnGroupHeader>
          {isGroupOpen && open ? (
            <LocationGroupOpenedQuestions
              questionsOrder={questionsOrder}
              formid={formid}
              groupid={groupid}
              isLastGroup={isLastGroup}
              locationid={locationid}
              customData={customData}
              isBuilding={isBuilding}
              buildingIndex={buildingIndex}
              currentnode={currentnode}
            ></LocationGroupOpenedQuestions>
          ) : null}
        </>
      }
    </div>
  );
};

export default BuildingGroupHeaderAndQuestions;
